var _path, _path2, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookingSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 139,
    viewBox: "0 0 120 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.37209 0C3.74831 0 0 3.74831 0 8.37209V117.958C0 120.76 1.37569 123.239 3.48831 124.759C3.34356 125.714 3.52721 126.736 4.12978 127.658L10.3005 137.105C11.9525 139.634 15.6577 139.634 17.3097 137.105L23.4805 127.658C23.7592 127.231 23.9483 126.783 24.0567 126.33H26.6478C26.7562 126.783 26.9453 127.231 27.224 127.658L33.3948 137.105C35.0468 139.634 38.7519 139.634 40.4039 137.105L46.5747 127.658C46.8534 127.231 47.0425 126.783 47.1509 126.33H49.6358C49.7419 126.773 49.9249 127.211 50.1935 127.63L56.1943 136.98C57.8416 139.547 61.5929 139.547 63.2402 136.98L69.2411 127.63C69.5096 127.211 69.6927 126.773 69.7987 126.33H72.2857C72.3941 126.783 72.5832 127.231 72.862 127.658L79.0327 137.105C80.6847 139.634 84.3899 139.634 86.0419 137.105L92.2126 127.658C92.4914 127.231 92.6805 126.783 92.7889 126.33H95.3797C95.4881 126.783 95.6772 127.231 95.9559 127.658L102.127 137.105C103.779 139.634 107.484 139.634 109.136 137.105L115.307 127.658C115.836 126.847 116.042 125.959 115.986 125.108C118.393 123.638 120 120.986 120 117.958V8.37209C120 3.74831 116.252 0 111.628 0H8.37209Z",
    fill: "#00A859",
    fillOpacity: 0.04
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4922 71.4581L53.8791 76.9846C54.7743 77.903 56.2505 77.903 57.1457 76.9846L72.9447 60.7764",
    stroke: "#00A859",
    strokeWidth: 3.48837,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.5355,
    cy: 69.4792,
    rx: 32.5434,
    ry: 32.1472,
    fill: "#00A859",
    fillOpacity: 0.08
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.7137,
    cy: 69.6568,
    rx: 23.7333,
    ry: 23.4444,
    fill: "#00A859",
    fillOpacity: 0.16
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingSuccess);
export default __webpack_public_path__ + "static/media/bookingSuccess.c7c9a1c24e141137637b6b1a02ac48a2.svg";
export { ForwardRef as ReactComponent };